import qs from 'qs'
import { constantRoutes, asyncRoutes, resetRouter } from '@/router'
import {
  setToken,
  getToken,
  removeToken,
  setLocalItem,
  getLocalItem,
  // removeLocalItem,
  clearLocalItem
} from '@/utils/auth'
import request from '@/utils/request'
import api from '@/api'

const getDefaultState = () => {
  return {
    token: getToken(),
    entry: getLocalItem(api.keys.entry),
    userInfo: getLocalItem(api.keys.user),
    // routes: getLocalItem(api.keys.menu)
    routes: [],
    btnPermission: getLocalItem(api.keys.btnPermission), //权限按钮 list
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_ENTRY: (state, value) => {
    state.entry = value
  },
  SET_USER: (state, data) => {
    state.userInfo = data
  },
  SET_ROUTES: (state, routes) => {
    state.routes = constantRoutes.concat(routes)
  },
  SET_BTNPERMISSION: (state, data) => {
    state.btnPermission = data
  },
}

const actions = {
  // 登录
  login({ commit }, option) {
    console.log("login,option",option)
    return new Promise((resolve, reject) => {
      const isAdmin = option.entry === 'admin'
      let apiUrl = ''
      let params = {}
      if (isAdmin) {
        apiUrl = api.user.login
        params = {
          instNo: option.instNo,
          username: option.username,
          password: option.password,
          captcha: option.captcha,
          captchaKey: option.captchaKey
        }
      } else {
        apiUrl = api.member.login
        params = {
          username: option.username,
          password: option.password,
          captchaValue: option.captcha,
          captchaKey: option.captchaKey
        }
      }
      request.post(apiUrl, qs.stringify(params)).then(res => {
        commit('SET_TOKEN', res.data.token)
        commit('SET_ENTRY', option.entry)

        setToken(res.data.token)
        setLocalItem(api.keys.entry, option.entry)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 退出登录
  logout({ dispatch }) {
    return new Promise((resolve, reject) => {
      request.get(api.user.logout).then(() => {
        dispatch('resetToken')
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 删除token & 本地存储
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken()
      resetRouter()
      clearLocalItem()
      commit('RESET_STATE')
      resolve()
    })
  },

  // 获取用户信息
  getUserInfo({ dispatch,commit },option) {
    return new Promise((resolve, reject) => {
      // rootGetters.isUser
      const isAdmin = option.entry === 'admin'
      let apiUrl = ''
      if (isAdmin) {
        apiUrl = api.user.info
        dispatch('setBtn')
      }else{
        apiUrl=api.member.info
      }
      request.get(apiUrl).then(res => {
        const { data } = res
        commit('SET_USER', data)
        setLocalItem(api.keys.user, data)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取用户按钮权限
  setBtn({ commit }) {
    return new Promise((resolve, reject) => {
      request.get(api.user.getusermenuperms).then(res => {
        const { data } = res
        commit('SET_BTNPERMISSION', data)
        setLocalItem(api.keys.btnPermission, data)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 获取用户菜单
  generateRoutes({ commit }) {
    return new Promise((resolve, reject) => {
      request.get(api.user.initMenuAll).then(res => {
        const accessedRoutes = filterAsyncRoutes(res.data)
        commit('SET_ROUTES', accessedRoutes)
        // setLocalItem(api.keys.menu, accessedRoutes)
        resolve(accessedRoutes)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

// 匹配动态路由
function filterAsyncRoutes(data = []) {
  let arrs = []
  let temp = {}
  data.forEach(item => {
    const index = asyncRoutes.findIndex(route => route.path === item.url)
    if (asyncRoutes[index]) {
      temp = {
        path: item.url,
        meta: { title: item.name, icon: item.icon },
      }
      if (item.subList && item.subList.length) {
        temp.children = filterAsyncRoutes(item.subList)
      }
      arrs.push(Object.assign(asyncRoutes[index], temp))
    }
  })
  return arrs
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
